module.exports = __webpack_public_path__ + "static/media/OmareSheilaKonne.04878eeb.jpeg";